// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"777":"81bd04f2b1e2ab8ca0b0","913":"af27eecc6b02f5a21c7f"}[chunkId] + ".js";
};